exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 767px) {\n.link[data-v-b4fa3a38] {\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n    letter-spacing: 0.2em;\n    display: block;\n}\n}\n", ""]);

// exports
